import { call, put, takeLatest } from "@redux-saga/core/effects";
import { AmenitiesTableApi } from "./AmenitiesTableApi";
import { AmenitiesTableconstant } from "./AmenitiesTableConstant";
import { AmenitiesTableParser } from "./AmenitiesTableParser";

function* getAmenitiestable() {
  try {
    yield put({ type: AmenitiesTableconstant.AMENITIES_TABLE_REQUEST });

    const res = yield call(AmenitiesTableApi.getAmenitiesTable);

    AmenitiesTableParser.getAmenitiesTableParser(res);

    yield put({
      type: AmenitiesTableconstant.AMENITIES_TABLE_RESPONSE,
      payload: res,
    });
  } catch (e) {
    console.log("Error", e);
    yield put({
      type: AmenitiesTableconstant.AMENITIES_TABLE_RESPONSE,
      payload: [],
    });
  }
}

// ***********Post_Saga*********

function* postAmenitiesSaga(payload) {
  try {
    yield put({ type: AmenitiesTableconstant.POST_AMENITIES_REQUEST });

    const res = yield call(AmenitiesTableApi.postAmenitiesApi, payload);

   

    yield put({
      type: AmenitiesTableconstant.POST_AMENITIES_RESPONSE,
      payload: res,
    });
  } catch (e) {
    console.log("Error", e);
    yield put({
      type: AmenitiesTableconstant.POST_AMENITIES_RESPONSE,
      payload: [],
    });
  }
}

//updateamenities

function* UpdateAmenitiesSaga(payload) {
  try {
    yield put({ type: AmenitiesTableconstant.UPDATE_AMENITIES_REQUEST });

    const res = yield call(AmenitiesTableApi.UpdateAmenitiesApi, payload);

    yield put({
      type: AmenitiesTableconstant.UPDATE_AMENITIES_RESPONSE,
      payload: res,
    });
  } catch (e) {
    console.log("Error", e);
    yield put({
      type: AmenitiesTableconstant.UPDATE_AMENITIES_RESPONSE,
      payload: [],
    });
  }
}

//enable/disable Add Amenities manufactuere

function* AddAmenitiesEnableDisable({ payload }) {
  const { id, status } = payload;

  try {
    yield put({
      type: AmenitiesTableconstant.ENABLE_DESABLE_AMENITIES_REQUEST,
    });
    const res = yield call(AmenitiesTableApi.AmenitiesEnableDisableApi, {
      id,
      status,
    });
    const payload = res;
    yield put({
      type: AmenitiesTableconstant.ENABLE_DESABLE_AMENITIES_RESPONSE,
      payload: payload,
    });
  } catch (e) {
    yield put({
      type: AmenitiesTableconstant.ENABLE_DESABLE_AMENITIES_RESPONSE,
      payload: [],
    });
  }
}

export function* registergetAmenitiestabletableSaga() {
  yield takeLatest(
    AmenitiesTableconstant.AMENITIES_TABLE_SAGA,
    getAmenitiestable
  );
  yield takeLatest(
    AmenitiesTableconstant.POST_AMENITIES_SAGA,
    postAmenitiesSaga
  );
  yield takeLatest(
    AmenitiesTableconstant.ENABLE_DESABLE_AMENITIES_SAGA,
    AddAmenitiesEnableDisable
  );
  yield takeLatest(
    AmenitiesTableconstant.UPDATE_AMENITIES_SAGA,
    UpdateAmenitiesSaga
  );
}
